// Čistá logika výběru varianty (`variantPicker.js`): z nativního textu volby
// Shoptetu udělá název parametru a hodnotu, seřadí velikosti a rozhodne, jestli
// patří cena do tlačítka. Nesahá na DOM — testuje ho `tools/unit/variant-picker.test.mjs`.

// Písmenné velikosti od nejmenší. Čísla (obuv 37–46) jdou za ně vzestupně,
// neznámé hodnoty drží pořadí Shoptetu na konci.
const LETTER_SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '4XL', '5XL', '6XL'];

/**
 * „Velikost: M - Skladem >5 ks (479 Kč)" (text `<option>`) nebo „Velikost: 42"
 * (`title` u obrázkové varianty) → `{ param, value, stock }`. Cenu v závorce na
 * konci ignoruje (tlačítko bere `data-customerprice`). Bez dvojtečky `null`.
 * `re` je regex z locale (`L.optionRe`), skupiny: 1 parametr, 2 hodnota, 3 stav.
 */
export function parseVariantText(raw, re) {
  const clean = String(raw || '')
    .replace(/\u00A0/g, ' ')
    // „(479 Kč)" / „(€6,11)" pryč, hodnota „L (52)" zůstává — cena má číslo I měnu
    .replace(/\s*\((?=[^()]*\d)(?=[^()]*[^\d\s.,()])[^()]*\)\s*$/, '')
    .replace(/\s+/g, ' ')
    .trim();
  const m = clean.match(re);
  if (!m || !m[1] || !m[2]) return null;
  return { param: m[1].trim(), value: m[2].trim(), stock: (m[3] || '').trim() };
}

/** Pořadí velikosti: písmenná podle tabulky, číselná vzestupně, jinak null. */
export function sizeRank(value) {
  const v = String(value || '').trim().toUpperCase();
  const i = LETTER_SIZES.indexOf(v);
  if (i >= 0) return i;
  const n = parseFloat(v.replace(',', '.'));
  if (/^\d+(?:[.,]\d+)?(?:\s*\/\s*\d+)?$/.test(v) && isFinite(n)) return 1000 + n;
  return null;
}

/**
 * Seřadí volby podle velikosti, jen když se dá seřadit KAŽDÁ (jinak nechá
 * pořadí Shoptetu — barvy, délky… se řadit nemají). Stabilní, vrací novou kopii.
 */
export function sortOptions(opts) {
  const ranks = opts.map((o) => sizeRank(o.label));
  if (ranks.some((r) => r == null)) return opts.slice();
  return opts
    .map((o, i) => ({ o: o, r: ranks[i], i: i }))
    .sort((a, b) => a.r - b.r || a.i - b.i)
    .map((x) => x.o);
}

/** Cena patří do tlačítka, jen když se ceny voleb liší (holiny 259 × 269 Kč). */
export function pricesDiffer(opts) {
  const prices = opts.map((o) => o.price).filter((p) => isFinite(p) && p > 0);
  return new Set(prices).size > 1;
}

/**
 * Počet kusů z nativního „(2 ks)" pro odznak nízké zásoby. Rozostřené „>5 ks",
 * nula nebo nad `max` = null (odznak se nekreslí). Pásma jako `stockLevel`.
 */
export function lowPieces(amountText, max) {
  const t = String(amountText || '');
  if (/>/.test(t)) return null;
  const n = parseInt((t.match(/(\d+)/) || [])[1], 10);
  if (!isFinite(n) || n <= 0 || n > max) return null;
  return n;
}
